"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGameEventDataSortToJSON = exports.GetGameEventDataSortFromJSONTyped = exports.GetGameEventDataSortFromJSON = exports.GetGameEventDataSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetGameEventDataSort;
(function (GetGameEventDataSort) {
    GetGameEventDataSort["CREATEDAT"] = "CREATED_AT";
})(GetGameEventDataSort = exports.GetGameEventDataSort || (exports.GetGameEventDataSort = {}));
function GetGameEventDataSortFromJSON(json) {
    return GetGameEventDataSortFromJSONTyped(json, false);
}
exports.GetGameEventDataSortFromJSON = GetGameEventDataSortFromJSON;
function GetGameEventDataSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetGameEventDataSortFromJSONTyped = GetGameEventDataSortFromJSONTyped;
function GetGameEventDataSortToJSON(value) {
    return value;
}
exports.GetGameEventDataSortToJSON = GetGameEventDataSortToJSON;
